/* eslint-disable complexity */
import { Permission } from '@futrli-sdk/workspaces';
import {
  matchConsolidationProductRoutePath,
  matchOrgProductPath,
  matchSettingsPath,
  useMobileOrTableWindowResize
} from '@futrli/shared-services';
import clsx from 'clsx';
import React from 'react';
import { Route, useLocation, Routes } from 'react-router-dom';

import { ProductsNavBarContainer } from '../../products/containers/products-navbar-container';
import { WorkspaceSettingsNavBarContainer } from '../containers/workspace-settings-navbar-container';
import { MobileNavBarScaffold } from '../../app/components/responsive/mobile-navbar-scaffold';
import { DesktopNavBarScaffold } from '../../app/components/responsive/desktop-navbar-scaffold';

import navbar from '../../app/components/navbar.scss';
import { HelpMenuContainer } from '../../help/components/help-menu-container';
import { ProfileMenu } from '../../profile/components/profile-menu';
import { OrganisationsMenu } from '../../settings/components/organisations-menu';

interface OwnProps {
  readonly permissions?: Permission[];
}

type Props = OwnProps;

export const WorkspacesNavBar: React.FC<Props> = ({ permissions }): JSX.Element => {
  const location = useLocation();
  const isMobileOrTableWS = useMobileOrTableWindowResize();

  if (isMobileOrTableWS) {
    return (
      <MobileNavBarScaffold
        main={
          <Routes>
            {matchSettingsPath(location.pathname) && <Route path="*" element={<WorkspaceSettingsNavBarContainer />} />}
            {(matchOrgProductPath(location.pathname) || matchConsolidationProductRoutePath(location.pathname)) && (
              <Route path="*" element={<ProductsNavBarContainer />} />
            )}
          </Routes>
        }
      />
    );
  }

  return (
    <DesktopNavBarScaffold
      customClassName={clsx(navbar.flexOneThird, navbar.fullHeight)}
      main={
        <>
          {permissions ? (
            <OrganisationsMenu permissions={permissions} />
          ) : (
            <Routes>
              {matchSettingsPath(location.pathname) && (
                <Route path="*" element={<WorkspaceSettingsNavBarContainer />} />
              )}
              {(matchOrgProductPath(location.pathname) || matchConsolidationProductRoutePath(location.pathname)) && (
                <Route path="*" element={<ProductsNavBarContainer />} />
              )}
            </Routes>
          )}
        </>
      }
      right={
        <div className={navbar.inner}>
          <ProfileMenu />
          <HelpMenuContainer />
        </div>
      }
    />
  );
};
